import { Link, useLocation } from "react-router-dom";

// Full-name lockup is the primary identity. Never reduce to a "K"/monogram.
export default function Logo({ variant = "horizontal", tone = "light", className = "", linked = true }) {
  const dark = tone === "dark";
  const { pathname } = useLocation();
  const src =
    variant === "stacked"
      ? dark ? "/brand/logo-stacked-white.png" : "/brand/logo-stacked-black.png"
      : dark ? "/brand/logo-horizontal-white.png" : "/brand/logo-horizontal-black.png";
  const img = <img src={src} alt="Kratos Venture Group" className={className} draggable="false" />;
  if (!linked) return img;

  // On the homepage, replay the cinematic intro (video + Enter screen) instead of a no-op same-route Link.
  const onClick = (e) => {
    if (pathname === "/") {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent("kv:hero-restart"));
    }
  };

  return (
    <Link to="/" onClick={onClick} aria-label="Kratos Venture Group — home" data-testid="brand-logo-link" className="inline-flex">
      {img}
    </Link>
  );
}
